/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { pluginPostbackChangeOrderRequestSchema } from "./pluginPostbackChangeOrderRequestSchema.ts";

export const callbackPluginCloseOrderCreateStatus200Schema = z.any();

export const callbackPluginCloseOrderCreateResponseSchema = callbackPluginCloseOrderCreateStatus200Schema;

export const callbackPluginCloseOrderCreateDataSchemaJson = pluginPostbackChangeOrderRequestSchema;

export const callbackPluginCloseOrderCreateDataSchemaXml = pluginPostbackChangeOrderRequestSchema;

export const callbackPluginCloseOrderCreateDataSchema = z.union([callbackPluginCloseOrderCreateDataSchemaJson, callbackPluginCloseOrderCreateDataSchemaXml]);
